import * as React from "react";
import { ModelControler } from "../../../service/modelController";
import { PriceService } from "../../../service/PriceService";
import "./Basket.css";

interface ProductInCart{
    name:string,
    price:number
}

interface BasketProps {

}

interface BasketState {
    products:ProductInCart[],
    isVisible:boolean
}

export class Basket extends React.Component<BasketProps, BasketState>{
    constructor(props: BasketProps) {
        super(props);
        this.state = {
            products: [],
            isVisible:false
        }
    }

    componentDidMount() {
        PriceService.instance.priceObserve.on('priceChange', () => this.checkBasket());
    }

    checkBasket(){
        var cart = [];    
        cart.push({name: ModelControler.instance.getCurrentProduct().product.getName(), price: ModelControler.instance.getCurrentProduct().product.getPrice()});
        ModelControler.instance.getFeatures().forEach((e)=>{
            if(e.getProduct()){
                cart.push({name:e.getProduct().getName(), price:e.getProduct().getPrice()})
            }
        })
        this.setState({
            products: cart
        })
    }

    toogleVisibility(){
        var newValue = !this.state.isVisible;
        this.setState({
            isVisible:newValue
        });
    }

    item = (product:ProductInCart) =>{
        return(
            <tr id="grill-basis-row">
                <td className="items-name">
                    {product.name}
                </td>
                <td id="grill-basis-price">
                    {product.price? product.price.toFixed(2):0}€
                </td>
            </tr>
        )
    }

    render() {
        if(this.state.isVisible){
            return (
                <div id="dropdown">
                    <table>
                        <tbody>
                        {this.state.products.map((product)=> {
                            return (
                                this.item(product) 
                            )                   
                        })}
                        </tbody>
                    </table>
                    <i id="rotate-icon" className="fas fa-caret-up" onClick={this.toogleVisibility.bind(this)}></i>
                </div>
            )
        }
        else{
            return (
                <div id="dropdown">
                    <i id="rotate-icon" className="fas fa-caret-down" onClick={this.toogleVisibility.bind(this)}></i>
                </div>
            )
        }
    }
}

//<hr className="white-line" />
//<i id="rotate-icon" className="fas fa-caret-down"></i>